<template>
  <div>
    <el-dialog title="巡检计划"
      :visible.sync="$parent.addPlanPopup"
      width="40%">
      <el-form :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
        style="width: 80%">
        <el-form-item label="巡检计划名称"
          prop="name">
          <el-input v-model="ruleForm.name"
            placeholder="请输入计划名称"></el-input>
        </el-form-item>
        <el-form-item label="巡检线路"
          prop="line">
          <el-select v-model="ruleForm.line"
            filterable
            placeholder="请选择巡检线路">
            <el-option v-for="item in lineList"
              :key="item.routeId"
              :label="item.name"
              :value="item.routeId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label=" 巡检计划类型"
          prop="type">
          <el-radio-group v-model="ruleForm.type">
            <el-radio label="CYCLE">循环计划</el-radio>
            <el-radio label="TEMPORARY">临时计划</el-radio>
          </el-radio-group>
        </el-form-item>
        <template v-if="ruleForm.type == 'CYCLE'">
          <el-form-item label=" 循环周期"
            prop="cycle">
            <el-radio-group v-model="ruleForm.cycle">
              <el-radio label="DAY">每天</el-radio>
              <el-radio label="WEEK">每周</el-radio>
              <el-radio label="MONTH">每月</el-radio>
            </el-radio-group>
          </el-form-item>
          <template v-if="ruleForm.cycle == 'DAY'">
            <el-form-item v-for="(v, i) in ruleForm.timeList"
              :label="'限时' + (i + 1)"
              :key="i">
              <el-time-picker is-range
                v-model="v.time"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                placeholder="选择时间范围"
                style="width: 65%; margin-right: 10px"
                size="small"
                format="HH:mm"
                value-format="HH:mm"
                :key="'timeList' + i">
              </el-time-picker>
              <el-button v-if="i !== 0"
                @click.prevent="removeTimeList(v)"
                size="small"
                icon="el-icon-minus"></el-button>
              <el-button v-if="i + 1 == ruleForm.timeList.length"
                @click.prevent="addTimeList(v)"
                icon="el-icon-plus"
                size="small"></el-button>
            </el-form-item>
          </template>
          <template v-if="ruleForm.cycle == 'WEEK'">
            <el-form-item v-for="(v, i) in ruleForm.weekTimeList"
              :label="'限时' + (i + 1)"
              :key="i">
              <el-select v-model="v.typeBegin"
                size="small"
                style="width: 30%">
                <el-option v-for="item in weekOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item">
                </el-option>
              </el-select>
              <el-time-picker v-model="v.beginTime"
                format="HH:mm"
                value-format="HH:mm"
                placeholder="开始时间"
                size="small"
                style="width: 45%"
                :key="'beginTime' + i">
              </el-time-picker>
              <el-select v-model="v.typeEnd"
                size="small"
                style="width: 30%">
                <el-option v-for="item in weekOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item">
                </el-option>
              </el-select>
              <el-time-picker v-model="v.endTime"
                format="HH:mm"
                value-format="HH:mm"
                placeholder="结束时间"
                size="small"
                style="margin-right: 10px; width: 45%"
                :key="'endTime' + i">
              </el-time-picker>
              <el-button v-if="i !== 0"
                @click.prevent="removeTimeList(v)"
                size="small"
                icon="el-icon-minus"></el-button>
              <el-button v-if="i + 1 == ruleForm.weekTimeList.length"
                @click.prevent="addTimeList(v)"
                icon="el-icon-plus"
                size="small"></el-button>
            </el-form-item>
          </template>
          <template v-if="ruleForm.cycle == 'MONTH'">
            <el-form-item v-for="(v, i) in ruleForm.monthTimeList"
              :label="'限时' + (i + 1)"
              :key="i">
              <el-select v-model="v.typeBegin"
                size="small"
                style="width: 30%">
                <el-option v-for="item in monthOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item">
                </el-option>
              </el-select>
              <el-time-picker v-model="v.beginTime"
                format="HH:mm"
                value-format="HH:mm"
                placeholder="开始时间"
                size="small"
                style="width: 45%"
                :key="'beginTime' + i">
              </el-time-picker>
              <el-select v-model="v.typeEnd"
                size="small"
                style="width: 30%">
                <el-option v-for="item in monthOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item">
                </el-option>
              </el-select>
              <el-time-picker v-model="v.endTime"
                format="HH:mm"
                value-format="HH:mm"
                placeholder="结束时间"
                size="small"
                style="margin-right: 10px; width: 45%"
                :key="'endTime' + i">
              </el-time-picker>
              <el-button v-if="i !== 0"
                @click.prevent="removeTimeList(v)"
                size="small"
                icon="el-icon-minus"></el-button>
              <el-button v-if="i + 1 == ruleForm.monthTimeList.length"
                @click.prevent="addTimeList(v)"
                icon="el-icon-plus"
                size="small"></el-button>
            </el-form-item>
          </template>
        </template>
        <template v-if="ruleForm.type == 'TEMPORARY'">
          <el-form-item label=" 选择日期">
            <el-date-picker v-model="ruleForm.temporaryTime"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm"
              size="small"
              :key="'temporaryTime'">
            </el-date-picker>
          </el-form-item>
        </template>
        <el-form-item label="巡检人"
          prop="user">
          <el-select v-model="ruleForm.user"
            filterable
            placeholder="请选择巡检人"
            multiple
            collapse-tags>
            <el-option v-for="item in userList"
              :key="item.userId"
              :label="item.userName"
              :value="item.userId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注">
          <el-input type="textarea"
            v-model="ruleForm.desc"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer"
        class="dialog-footer">
        <el-button @click="$parent.addPlanPopup = false">取 消</el-button>
        <el-button type="primary"
          @click="submitForm('ruleForm')"
          :loadin="btnLoading">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import api from "@/api";
import { dateFtt } from "@/assets/js/utils";
export default {
  props: ["clickRow"],
  data() {
    return {
      weekOptions: [
        {
          value: "Monday",
          label: "周一",
          id: 1,
        },
        {
          value: "Tuesday",
          label: "周二",
          id: 2,
        },
        {
          value: "Wednesday",
          label: "周三",
          id: 3,
        },
        {
          value: "Thursday",
          label: "周四",
          id: 4,
        },
        {
          value: "Friday",
          label: "周五",
          id: 5,
        },
        {
          value: "Saturday",
          label: "周六",
          id: 6,
        },
        {
          value: "Sunday",
          label: "周日",
          id: 7,
        },
      ],
      monthOptions: [],
      value: "",
      ruleForm: {
        name: "",
        line: "",
        type: "CYCLE",
        cycle: "DAY",
        user: [],
        desc: "",
        timeList: [{ time: null }],
        weekTimeList: [
          { typeBegin: "", typeEnd: "", beginTime: "", endTime: "" },
        ],
        monthTimeList: [
          { typeBegin: "", typeEnd: "", beginTime: "", endTime: "" },
        ],
        temporaryTime: [], //临时计划时间
      },
      rules: {
        name: [
          { required: true, message: "请输入巡检计划" },
          { whitespace: true, message: "计划名称不能为空" },
          { min: 5, max: 20, message: "请输入 5 到 20 个字", trigger: "blur" },
        ],
        line: [{ required: true, message: "请选择巡检路线" }],
        type: [{ required: true, message: "请选择巡检计划类型" }],
        cycle: [{ required: true, message: "请选择循环周期" }],
        user: [{ required: true, message: "请选择巡检人" }],
      },
      lineList: [],
      userList: [],
      planTimeLimits: [],
      btnLoading: false,
    };
  },
  methods: {
    checkTimeList() {
      this.planTimeLimits = [];
      let dateArr = [];
      this.ruleForm.timeList.map((v) => {
        if (v.time && v.time.length) {
          dateArr.push({
            typeBeginTime: "",
            typeEndTime: "",
            beginTime: v.time[0],
            endTime: v.time[1],
          });
        }
      });
      if (dateArr.length == 0) {
        this.$message.error("请选择时间范围");
      } else {
        if (!Fn()) {
          this.$message.error("时间段有重叠，请检查!");
        } else {
          this.planTimeLimits = dateArr;
        }
      }
      function Fn() {
        for (let k in dateArr) {
          if (!judege(k)) {
            return false;
          }
        }
        return true;
      }
      function judege(idx) {
        for (let k in dateArr) {
          if (idx !== k) {
            if (
              dateArr[k].beginTime <= dateArr[idx].beginTime &&
              dateArr[k].endTime > dateArr[idx].beginTime
            ) {
              return false;
            }
            if (
              dateArr[k].beginTime < dateArr[idx].endTime &&
              dateArr[k].endTime >= dateArr[idx].endTime
            ) {
              return false;
            }
          }
        }
        return true;
      }
    },
    checkWeekTimeList(list) {
      let dataArr = [];
      this.planTimeLimits = [];
      for (let i = 0; i < list.length; i++) {
        if (
          !list[i].beginTime ||
          !list[i].endTime ||
          !list[i].typeBegin ||
          !list[i].typeEnd
        ) {
          return this.$message.error("请选择完整的时间周期");
        } else {
          if (
            list[i].typeEnd.id < list[i].typeBegin.id ||
            (list[i].typeEnd.id == list[i].typeBegin.id &&
              list[i].endTime <= list[i].beginTime)
          ) {
            return this.$message.error("结束时间早于开始时间，请检查!");
          } else {
            dataArr.push({
              startTime: `2022-01-${
                list[i].typeBegin.id <= 9
                  ? "0" + list[i].typeBegin.id
                  : list[i].typeBegin.id
              } ${list[i].beginTime}:00`,
              endTime: `2022-01-${
                list[i].typeEnd.id <= 9
                  ? "0" + list[i].typeEnd.id
                  : list[i].typeEnd.id
              } ${list[i].endTime}:00`,
            });
          }
        }
      }
      if (checkRow()) {
        // 返回的结果为true表示有重复区间，false则表示没有
        return this.$message.error("时间段有重叠，请检查!");
      } else {
        this.planTimeLimits = Array.from(list).map((item) => ({
          typeBeginTime: item.typeBegin.value,
          typeEndTime: item.typeEnd.value,
          beginTime: item.beginTime,
          endTime: item.endTime,
        }));
      }
      function checkRow() {
        let startTimeArr = [];
        let endTimeArr = [];
        dataArr.map((item) => {
          startTimeArr.push(
            item.startTime ? new Date(item.startTime).getTime() : ""
          );
          endTimeArr.push(item.endTime ? new Date(item.endTime).getTime() : "");
        });
        let allStartTime = startTimeArr.sort(); // 排序
        let allEndTime = endTimeArr.sort();
        let result = 0; // 判断时间是否有重复区间
        for (let k = 0; k < allStartTime.length; k++) {
          if (k > 0) {
            if (allStartTime[k] <= allEndTime[k - 1]) {
              result += 1;
            }
          }
        }
        return result > 0;
      }
    },
    checkTemporary() {
      //校验处理临时计划时间范围
      this.planTimeLimits = [];
      if (
        !this.ruleForm.temporaryTime ||
        this.ruleForm.temporaryTime.length == 0
      ) {
        return this.$message.error("请选择日期范围");
      } else {
        this.planTimeLimits = [
          {
            typeBeginTime: dateFtt(
              "yyyy-MM-dd",
              new Date(this.ruleForm.temporaryTime[0])
            ),
            typeEndTime: dateFtt(
              "yyyy-MM-dd",
              new Date(this.ruleForm.temporaryTime[1])
            ),
            beginTime: dateFtt(
              "hh:mm",
              new Date(this.ruleForm.temporaryTime[0])
            ),
            endTime: dateFtt("hh:mm", new Date(this.ruleForm.temporaryTime[1])),
          },
        ];
      }
    },
    addTimeList() {
      if (this.ruleForm.cycle == "DAY") {
        this.ruleForm.timeList.push({ time: null });
      } else if (this.ruleForm.cycle == "WEEK") {
        this.ruleForm.weekTimeList.push({
          typeBegin: "",
          typeEnd: "",
          beginTime: "",
          endTime: "",
        });
      } else if (this.ruleForm.cycle == "MONTH") {
        this.ruleForm.monthTimeList.push({
          typeBegin: "",
          typeEnd: "",
          beginTime: "",
          endTime: "",
        });
      }
    },
    removeTimeList(item) {
      if (this.ruleForm.cycle == "DAY") {
        let index = this.ruleForm.timeList.indexOf(item);
        if (index !== -1) {
          this.ruleForm.timeList.splice(index, 1);
        }
      } else if (this.ruleForm.cycle == "WEEK") {
        let index = this.ruleForm.weekTimeList.indexOf(item);
        if (index !== -1) {
          this.ruleForm.weekTimeList.splice(index, 1);
        }
      } else if (this.ruleForm.cycle == "MONTH") {
        let index = this.ruleForm.monthTimeList.indexOf(item);
        if (index !== -1) {
          this.ruleForm.monthTimeList.splice(index, 1);
        }
      }
    },
    submitForm(formName) {
      // console.log(this.ruleForm.temporaryTime);
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.ruleForm.type == "TEMPORARY") {
            this.checkTemporary();
          } else {
            if (this.ruleForm.cycle == "DAY") {
              this.checkTimeList();
            } else if (this.ruleForm.cycle == "WEEK") {
              this.checkWeekTimeList(this.ruleForm.weekTimeList);
            } else if (this.ruleForm.cycle == "MONTH") {
              this.checkWeekTimeList(this.ruleForm.monthTimeList);
            }
          }
          if (this.planTimeLimits.length > 0) {
            return new Promise(async (resolve) => {
              this.btnLoading = true;
              let handlersInfo = [];
              this.ruleForm.user.map((v) => {
                handlersInfo.push({ id: v });
              });
              let res = await api.patrolPlanEditAdd({
                id: this.clickRow.id ? this.clickRow.id : "",
                name: this.ruleForm.name,
                inspectionRouteId: this.ruleForm.line,
                remark: this.ruleForm.desc,
                planType: this.ruleForm.type,
                planCycle:
                  this.ruleForm.type == "CYCLE"
                    ? this.ruleForm.cycle
                    : "UNLIMITED",
                planTimeLimits: this.planTimeLimits,
                handlersInfo: handlersInfo,
                sourceType: "INSPECTION",
              });
              // console.log(res);
              if (res && res.data.code == 200) {
                this.$message.success("添加成功");
                this.$store.commit("SET_LOADING", true);
                this.$parent.addPlanPopup = false;
                setTimeout(() => {
                  this.$parent.getList();
                }, 1000);
              } else if (res && res.data.code == "00003") {
                this.btnLoading = false;
                this.$message.error(res.data.data);
              }
              resolve();
            });
          }
        } else {
          return false;
        }
      });
    },
    async getLineList() {
      let res = await api.patrolPlanGetLine({
        sourceType: "INSPECTION",
      });
      if (res && res.data.code == 200) {
        this.lineList = res.data.data;
      }
    },
    async getUserList() {
      let res = await api.projectGetUserListByPower({
        permission: "houqinguanli:xunjianguanli:patrolPlan:edit",
      });
      if (res && res.data.code == 200) {
        this.userList = res.data.data;
      }
    },
    handleDefault() {
      this.ruleForm.name = this.clickRow.name;
      this.ruleForm.line = this.clickRow.inspectionRouteId;
      this.ruleForm.type = this.clickRow.planType;
      this.ruleForm.cycle = this.clickRow.planCycle;
      this.ruleForm.desc = this.clickRow.remark;
      this.ruleForm.user = [];
      this.clickRow.handlersInfo.map((v) => {
        this.ruleForm.user.push(v.id);
      });
      if (this.ruleForm.type == "TEMPORARY") {
        this.ruleForm.temporaryTime = [];
        let s = `${this.clickRow.planTimeLimits[0].typeBeginTime} ${this.clickRow.planTimeLimits[0].beginTime}`;
        let e = `${this.clickRow.planTimeLimits[0].typeEndTime} ${this.clickRow.planTimeLimits[0].endTime}`;
        this.ruleForm.temporaryTime = [s, e];
      } else {
        if (this.ruleForm.cycle == "DAY") {
          this.ruleForm.timeList = Array.from(this.clickRow.planTimeLimits).map(
            (item) => ({
              time: [item.beginTime, item.endTime],
            })
          );
        } else if (this.ruleForm.cycle == "WEEK") {
          this.ruleForm.weekTimeList = Array.from(
            this.clickRow.planTimeLimits
          ).map((item) => ({
            typeBegin: this.weekOptions.find((v) => {
              return v.value == item.typeBeginTime;
            }),
            typeEnd: this.weekOptions.find((v) => {
              return v.value == item.typeEndTime;
            }),
            beginTime: item.beginTime,
            endTime: item.endTime,
          }));
        } else if (this.ruleForm.cycle == "MONTH") {
          this.ruleForm.monthTimeList = Array.from(
            this.clickRow.planTimeLimits
          ).map((item) => ({
            typeBegin: this.monthOptions.find((v) => {
              return v.value == item.typeBeginTime;
            }),
            typeEnd: this.monthOptions.find((v) => {
              return v.value == item.typeEndTime;
            }),
            beginTime: item.beginTime,
            endTime: item.endTime,
          }));
        }
      }
    },
  },
  created() {
    for (let i = 0; i < 31; i++) {
      this.monthOptions.push({
        value: i + 1 + "号",
        label: i + 1 + "号",
        id: i + 1,
      });
    }
    if (this.clickRow.id) {
      this.handleDefault();
    }
    this.getLineList();
    this.getUserList();
  },
};
</script>

<style lang="scss">
</style>